import clsx from "clsx";
import { DeltaType, MetricConfig } from "@/features/Metrics/Metrics.types";
import { MetricValue } from "./MetricValue";
import { DeltaValue } from "./DeltaValue";
import { MetricQueryString } from "@/entities/Finance/models/MetricQueryString.model";

export interface DetailGridMetricProps {
    config: MetricConfig;
    query: MetricQueryString;
    deltaType: DeltaType;
    panelTitle?: string;
}

export function DetailGridMetric({
    config,
    query,
    deltaType,
    panelTitle,
}: DetailGridMetricProps) {
    return (
        <>
            <span
                className={clsx(
                    "heading-s flex min-h-12 w-1/3 min-w-[108px] cursor-pointer items-center break-words",
                )}
            >
                {config.label}
            </span>

            <MetricValue
                query={query}
                config={config}
                panelTitle={panelTitle}
            />

            <DeltaValue deltaType={deltaType} config={config} />
        </>
    );
}
